var contacts = {
    list: function(page){
        var params = utils.getParamObj();
        params.like = $("#like").val();
        params.page = page || 1;
        var getParams = location.pathname+"?"+($.param(params));
        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams,params,function(resp){
                $("#contact_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    saveContact: function(ticketing){
        ticketing = ticketing || false;
        var params = $("form#user :input").serializeObj();
        // params._token = utils.getToken();
        params.ticketing = ticketing;

        $.post('/admin/contacts/save',params,function(resp){
            if(ticketing == 1){
                var selectOptions = "";

                $.each(resp.contactsData, function(id, contact){
                    selectOptions += '<option value="' + contact.id + '" ' + (parseInt(contact.id) == parseInt(resp.contactID) ? ' selected="selected" ':'') + ">" + contact.text + "</option>";

                    if(contact.id == resp.contactID){
                        console.debug(contact.text);
                    }
                });

                $("#contactID").html(selectOptions);
                $('#contactID').trigger('change');
                closeLastPopup();
            }else {
                location.reload();
            }
        },'json').fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    state: function(contactID, state){
        $.post('/admin/contacts/state/'+contactID+'/'+state,{/*'_token':utils.getToken()*/},function(resp){
            location.reload();
        });
    },
    selectContact: function(){
        if($("#contactID").val() > 0) {
            var params = utils.getParamObj();
            params.contactID = $("#contactID").val();
            $.post('/admin/contacts/selectContact', params, function (resp) {
                //$.each(resp.contact, function(paramName, paramValue){
                //    if($("#"+paramName).length > 0){
                //        $("#"+paramName).val(paramValue);
                //    }
                //});
                //if(resp.availabilities.length > 0){
                //    $.each(resp.availabilities, function(paramName, availability){
                //        $("input[data-type='"+availability.availabilityID+"']").val(availability.availability_value);
                //    })
                //}else{
                //    $("[id^=availability_]").val('');
                //}
                $(".contact").addClass('hidden');
            });
        }else if($("#contactID").val() == 0){
            $(".contact").removeClass('hidden');
        }else{
            $(".contact").addClass('hidden');
            $("[id^=contact_]").val('');
            $("[id^=availability_]").val('');
        }
    }
};